<template>
    <DModal
        v-model="downgradeForm.activity_log_comment"
        :show="showModal"
        :title="__('customers.contracts.downgrade_contract_title')"
        :is-big="true"
        is-awaiting-validation
        :show-change-reason-input="true"
        close-color-secondary
        :show-incident-list="true"
        :customer-id="contract?.customer_id ?? 0"
        @setIncident="setIncident"
        @update:show="$emit('update:showModal', $event)"
        @close="$emit('close-modal', false)"
        @clearFields="resetDowngradeForm()"
    >
        <div style="padding: 15px;">
            <!-- Product -->
            <ProductChangesSelection
                v-if="activeProductId !== 0"
                label-col="3"
                select-col="8"
                :label="__('customers.contracts.product')"
                :product-id="activeProductId"
                :ignore-current="false"
                :multiple="false"
                :errors="errors"
                :required="true"
                :available-products="'downgrade'"
                :market-region-id="marketRegionId"
                @update="loadProductPlans"
            />

            <!-- Price Plan -->
            <DFormRow
                :label="__('customers.contracts.product_plan')"
                :error="errors.plan_id"
                is-required
            >
                <DSelect
                    id="product_plan"
                    v-model="downgradeForm.plan_id"
                    :options="pricePlans"
                    :placeholder="__('customers.contracts.select_product_plan')"
                    @update="resetForce()"
                />
            </DFormRow>

            <!-- Start Date -->
            <DFormRow
                :label="__('customers.contracts.start_date')"
                :error="errors.start_date"
                is-required
            >
                <DDateFormatInput
                    id="start_date"
                    v-model="downgradeForm.start_date"
                    format="YYYY-MM-DD"
                    add-label-classes="required"
                    type="date"
                    @valueChanged="resetForce"
                />
            </DFormRow>
        </div>
        <template #actions>
            <DAlert
                v-if="errors.warning"
                class="m-0"
                color="warning"
            >
                {{ errors.warning }}
            </DAlert>
            <DButton
                v-if="downgradeForm.force === false"
                :label="__('messages.confirm')"
                :disabled="isInLoadingState"
                color="primary"
                @click="downgradeConfirm"
            />
            <DButton
                v-else
                :label="__('messages.apply')"
                :disabled="isInLoadingState"
                class="ms-1"
                color="success"
                @click="downgradeConfirm"
            />
        </template>
    </DModal>
</template>

<script>

import ProductChangesSelection from '~@/Components/Products/Products/ProductChangesSelection'

export default {
    name: 'DowngradeContract',
    components: {
        ProductChangesSelection
    },
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        activeProductId: {
            type: Number,
            default: 0
        },
        errorsData: {
            type: Object,
            default: () => { return {} }
        },
        marketRegionId: {
            type: Number,
            default: null
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            downgradeForm: this.$inertia.form({
                product_id: null,
                plan_id: null,
                start_date: new Date().toISOString().split('T')[0],
                force: false,
                activity_log_comment: '',
                incident_id: null
            }),
            errors: this.errorsData,
            pricePlans: []
        }
    },
    methods: {
        loadProductPlans (value) {
            this.downgradeForm.product_id = value.value
            this.resetForce()

            const fetchData = async () => {
                const { data: pricePlans } = await window.axios.get(this.$route('products.dropdown.plans', {
                    product: this.downgradeForm.product_id,
                    market_region_id: this.marketRegionId
                }))

                this.pricePlans = pricePlans
            }

            fetchData()
        },
        downgradeConfirm () {
            this.downgradeForm.post(this.$route('customers.customers.contracts.downgrade', {
                customer: this.contract.customer_id,
                contract: this.contract.id
            }), {
                onSuccess: (response) => {
                    const changed = response.props.flash.errorMessage === null
                    this.$emit('close-modal', changed)
                    this.resetDowngradeForm()
                },
                onError: (error) => {
                    this.errors = error
                    if (this.errors.warning) {
                        this.downgradeForm.force = true
                    }
                }
            })
        },
        resetDowngradeForm () {
            this.downgradeForm.product_id = null
            this.downgradeForm.plan_id = null
            this.downgradeForm.start_date = new Date().toISOString().split('T')[0]
            this.downgradeForm.force = false
            this.downgradeForm.incident_id = null
            this.errors = {}
        },
        resetForce () {
            this.downgradeForm.force = false
        },
        setIncident (value) {
            this.downgradeForm.incident_id = value
        }
    }
}
</script>

<style scoped>

</style>
